import React, { Component } from 'react';
import { ItemsList } from './ItemsList';

export class ScanItems extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.focusInput('putawayItem');
    }


    render() {
        return (
            <div>
                <div className="close-session">
                    <h3>{this.props.putawayCart}</h3>
                    <button onClick={() => { this.props.closeSession() }}>Finish Session</button>
                </div>
                <div className="horizontalInput">
                    <h3>Scan an Item</h3>
                    <input type="text" value={this.props.putawayItem} id="putawayItem" onBlur={() => { this.props.focusInput('putawayItem') }} onChange={(e) => { this.props.updateInputValue(e) }} />
                </div>
                    <ItemsList
                        putawayItems={this.props.putawayItems}
                    />
            </div>
        );
    }
}